import { Box, IconButton, Tooltip } from '@mui/material';
import { FC, ReactNode } from 'react';

type Props = {
  title: string;
  disabled: boolean;
  onClick: () => void;
  icon: ReactNode;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
};

const ActionButton: FC<Props> = ({ title, disabled, onClick, icon, color = 'primary' }) => (
  <Tooltip title={disabled ? 'Not available for some selected items' : title} arrow>
    <Box component="span">
      <IconButton
        color={color}
        disabled={disabled}
        onClick={onClick}
        aria-label={disabled ? 'Not available for some selected items' : title}
      >
        {icon}
      </IconButton>
    </Box>
  </Tooltip>
);

export default ActionButton;
